module.exports = __webpack_public_path__ + "img/world-top-right.ab124ae2.png";